// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#plusPage{\n  height: 100vh;\n  background-image: linear-gradient(#4B4847,#342319);\n}\n", ""]);
// Exports
module.exports = exports;
